import React from "react";
import SaleProduct from "./SaleProduct";
import HireProduct from "./HireProduct";

function Product({acctCustomer, product, hireOrSale}) {
    return (
        <>{acctCustomer && product.acfProducts && product.acfProducts.productType !== 'SALE' && hireOrSale !== 'SALE' ? <HireProduct {...product}/> : <SaleProduct {...product}/>}</>
    )
}

export default Product;